import React from "react";
import { useLang } from "@/context/LanguageContext";

const MAP = {
  Active: "bg-blue-50 text-blue-700 border-blue-200",
  Inactive: "bg-orange-50 text-orange-700 border-orange-200",
  Settled: "bg-green-50 text-green-700 border-green-200",
  "Bad Debt": "bg-red-50 text-red-700 border-red-200",
};

export function StatusBadge({ status, inactive, testid }) {
  const { tv } = useLang();
  const label = inactive && status === "Active" ? "Inactive" : status;
  const cls = MAP[label] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span
      data-testid={testid || "status-badge"}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold border ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {tv(label)}
    </span>
  );
}

export function RiskBadge({ riskTag }) {
  const { tv } = useLang();
  if (!riskTag || riskTag === "None") return <span className="text-slate-300 text-xs">—</span>;
  return (
    <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border bg-amber-50 text-amber-800 border-amber-200">
      {tv(riskTag)}
    </span>
  );
}

const COLLECTION_CLS = {
  "Due Today": "bg-blue-50 text-blue-700 border-blue-200",
  Overdue: "bg-amber-50 text-amber-800 border-amber-200",
  Upcoming: "bg-slate-100 text-slate-600 border-slate-200",
  "Red Flag": "bg-red-50 text-red-700 border-red-200",
  "White Board": "bg-slate-900 text-white border-slate-900",
};

export function CollectionStateBadge({ state }) {
  const { tv } = useLang();
  if (!state) return <span className="text-slate-300 text-xs">—</span>;
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border whitespace-nowrap ${COLLECTION_CLS[state] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {tv(state)}
    </span>
  );
}
